import { useDeepCompareEffect } from "@react-hookz/web";
import { useSetAtom } from "jotai";
import { useCallback } from "react";

import type { AdSlotState } from "./atoms";
import { defaultTopBannerAdSlotStateAtom, topBannerAdSlotAtom } from "./atoms";

export const useTopBannerAdSlot = (state: Omit<AdSlotState, "manualRefreshCount">) => {
  const setState = useSetAtom(topBannerAdSlotAtom);
  useDeepCompareEffect(() => {
    setState(previous => ({ ...state, manualRefreshCount: previous.manualRefreshCount }));
    return () => setState(defaultTopBannerAdSlotStateAtom);
  }, [state, setState]);

  const refresh = useCallback(() => {
    setState(previous => ({
      ...previous,
      manualRefreshCount: (previous.manualRefreshCount ?? 0) + 1,
    }));
  }, [setState]);

  return { refresh };
};
